import React from 'react';
import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const StyledPaper = styled(({ ...otherProps }) => (
  <Paper {...otherProps} />
))`
  border-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  padding: 22px !important;
`;
